<template>
    <div id="app">
      <div class="loader loading_whole" style="height: 100vh"
           v-if="loadingApi">
        <div class="modified-loader">
          <loading></loading>
        </div>
      </div>
      <router-view v-else></router-view>
      <error-popup v-if="failed === true || !!failed"></error-popup>
    </div>
  </template>
  <script>
  import errorPopup from '@/components/error-popup'
  import {mapActions, mapMutations, mapState} from 'vuex'
  import CommonUtils from "@/utils";
  import localizationKeys from "../../../localization_keys.json";
  import loading from '@/components/common/loading.vue';
  import CountryCurrencies from "@/assets/country-currencies/country_currencies.json"
  import languageCodes from "@/assets/languageCodes"


  export default {
    data() {
      return {
        loadingApi : false
      }
    },
    components: {
      errorPopup,
      loading
    },
    computed: {
      ...mapState({
        failed: state => state.api_fail,
        mobileView: state => state.mobileView,
        hotel: state => state.property.details,
        property: state => state.property.details,
        property_language_code: state => state.property.details.language,
        property_languages: state => state.property.details.property_languages,
        localization_language: state => state.localization_language,
        disableSearchButton: state => state.disableSearchButton,

      }),
    },
    methods: {
      ...mapActions({
        getHotelDetails: 'property/getHotelDetails',
        GET_LOCALIZATION_KEYS: 'configs/getLocalizationKeys',
        userDetails: 'userDetails',
        setWizardSteps: 'property/setWizardSteps',
        getBookingProfile: 'getBookingProfile',
      }),
      ...mapMutations({
        SET_ERROR: 'SET_ERROR',
        SET_MOBILE_VIEW: 'SET_MOBILE_VIEW',
        SET_LOGGED_IN_USER_DETAILS: 'SET_LOGGED_IN_USER_DETAILS',
        RESET_STATE: 'RESET_STATE',
        SET_EDIT_STAY_DETAILS: 'SET_EDIT_STAY_DETAILS',
        SET_RESERVATION_ADDONS: 'SET_RESERVATION_ADDONS',
        SET_KEY_FROM_URL: 'SET_KEY_FROM_URL',
        SET_TOKEN_FROM_URL: 'SET_TOKEN_FROM_URL',
        CHANGE_STEP: 'CHANGE_STEP',
        SET_DISABLE_SEARCH_BUTTON: 'SET_DISABLE_SEARCH_BUTTON',
        SET_COUNTRY_CODE: 'SET_COUNTRY_CODE',
        SET_LOCALIZATION_LANGUAGE: 'SET_LOCALIZATION_LANGUAGE',
        SET_LOCALIZATION_CURRENCY: 'SET_LOCALIZATION_CURRENCY'

      }),

      setCustomColor() {
        let sx = this.property.website_config.booking_color_id.split('#')
        let x = '%23' + sx[1]
        let a = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 29.121 29.121' style='enable-background:new 0 0 29.121 29.121;' xml:space='preserve' width='512px' height='512px' class=''%3E%3Cg%3E%3Cg%3E%3Cpath d='M21.706,6.146c1.116,0,2.02-0.898,2.02-2.016V2.02c0-1.119-0.903-2.02-2.02-2.02 s-2.019,0.9-2.019,2.02v2.111C19.688,5.248,20.59,6.146,21.706,6.146z' data-original='%23030104' class='active-path' data-old_color='%23030104' fill='${x}' /%3E%3Cpath d='M28.882,3.494h-4.066v1.027c0,1.695-1.377,3.076-3.075,3.076c-1.7,0-3.074-1.381-3.074-3.076V3.494 h-8.205v1.027c0,1.695-1.379,3.076-3.076,3.076s-3.075-1.38-3.075-3.076V3.494L0.208,3.443v25.678H2.26h24.604l2.049-0.006 L28.882,3.494z M26.862,27.076H2.26V10.672h24.604v16.404H26.862z' data-original='%23030104' class='active-path' data-old_color='%23030104' fill='${x}' /%3E%3Cpath d='M7.354,6.146c1.116,0,2.021-0.898,2.021-2.016V2.02C9.375,0.9,8.47,0,7.354,0S5.336,0.9,5.336,2.02 v2.111C5.336,5.248,6.237,6.146,7.354,6.146z' data-original='%23030104' class='active-path' data-old_color='%23030104' fill='${x}' /%3E%3Crect x='10.468' y='12.873' width='3.231' height='2.852' data-original='%23030104' class='active-path' data-old_color='%23030104' fill='${x}' /%3E%3Crect x='15.692' y='12.873' width='3.234' height='2.852' data-original='%23030104' class='active-path' data-old_color='%23030104' fill='${x}' /%3E%3Crect x='20.537' y='12.873' width='3.231' height='2.852' data-original='%23030104' class='active-path' data-old_color='%23030104' fill='${x}' /%3E%3Crect x='10.468' y='17.609' width='3.231' height='2.85' data-original='%23030104' class='active-path' data-old_color='%23030104' fill='${x}' /%3E%3Crect x='15.692' y='17.609' width='3.234' height='2.85' data-original='%23030104' class='active-path' data-old_color='%23030104' fill='${x}' /%3E%3Crect x='20.537' y='17.609' width='3.231' height='2.85' data-original='%23030104' class='active-path' data-old_color='%23030104' fill='${x}' /%3E%3Crect x='10.468' y='22.439' width='3.231' height='2.85' data-original='%23030104' class='active-path' data-old_color='%23030104' fill='${x}' /%3E%3Crect x='5.336' y='17.609' width='3.229' height='2.85' data-original='%23030104' class='active-path' data-old_color='%23030104' fill='${x}' /%3E%3Crect x='5.336' y='22.439' width='3.229' height='2.85' data-original='%23030104' class='active-path' data-old_color='%23030104' fill='${x}'/%3E%3Crect x='15.692' y='22.439' width='3.234' height='2.85' data-original='%23030104' class='active-path' data-old_color='%23030104' fill='${x}' /%3E%3Crect x='20.537' y='22.439' width='3.231' height='2.85' data-original='%23030104' class='active-path' data-old_color='%23030104' fill='${x}' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        document.documentElement.style.setProperty('--hex-primary-color', `${a}`);
        document.documentElement.style.setProperty('--primary-color', `${this.property.website_config.booking_color_id}`);
      },
      injectScript() {
        if (this.property && this.property.website_config && this.property.website_config.injected_scripts) {
          const scripts = this.property.website_config.injected_scripts.split(',');
          scripts.forEach(script => {
            let tag = document.createElement("script");
            tag.setAttribute("src", script);
            document.head.appendChild(tag);
          });
        }
      },
      async successCallback(position) {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;
      await this.reverseGeocode(latitude,longitude)
    },
    errorCallback(error) {
      console.error("Error getting geolocation:", error.message);
      this.SET_DISABLE_SEARCH_BUTTON(false)
    },
    async reverseGeocode(latitude, longitude) {
      // const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyCZXHB4jp1bELmPjHXIUDvXLKxUliitp-s`;

      // try {
      //   // this.loading = true
      //   const response = await fetch(apiUrl);
      //   const data = await response.json();
      //
      //
      //   let country;
      //   let countryCode;
      //   for (const result of data.results) {
      //     for (const component of result.address_components) {
      //       if (component.types.includes('country')) {
      //         country =  component.long_name;
      //         countryCode = component.short_name;
      //         // return;
      //       }
      //     }
      //   }
      //   const userCountry =  CountryCurrencies.find(item => item.country === country?.toUpperCase())
      //   const  userLanguage = languageCodes.find(item => item.countryCode === countryCode?.toUpperCase() )
        this.SET_DISABLE_SEARCH_BUTTON(false)
        // if((this.disableSearchButton === false) || this.$route.query.skip_search) {
          // this.hotel.currency =  userCountry?.code || this.hotel.currency || 'USD'
          // // this.hotel.language = userLanguage?.code || this.hotel.language
          // this.SET_LOCALIZATION_LANGUAGE(userLanguage?.code)
          // this.SET_LOCALIZATION_CURRENCY(userCountry?.code)
          // this.SET_COUNTRY_CODE(countryCode)
        // }
        // else {
        //   this.hotel.currency = this.hotel.currency || 'USD'
        // }
      // } catch (error) {
      //   console.error("Error in reverse geocoding:", error);
      //   this.SET_DISABLE_SEARCH_BUTTON(false)
      // }
    },
      async checkUserAuth(res) {
        if (res?.website_config?.enable_loyalty_flow) {
          this.loadingUser = true
          await this.userDetails()
          this.loadingUser = false
        }
        const defaultLanguage = this.property_languages?.find(lang => lang?.default)?.language_code

        let user_language = this.localization_language || defaultLanguage || this.property_language_code || CommonUtils.getCookie('hk_language').substring(0, 2) || 'en'


        this.GET_LOCALIZATION_KEYS().then(locRes => {
          this.$i18n.locale = user_language
          this.$i18n.setLocaleMessage(user_language, locRes?.data);
        }).catch(() => {
          this.SET_ERROR(false)
          this.$i18n.locale = user_language
          this.$i18n.setLocaleMessage(user_language, localizationKeys);
        }).finally(() => {
          this.initial_data_loaded = true;
        })
      },
      handleGeolocation() {
        return new Promise((resolve, reject) => {
          if (navigator.geolocation) {

            this.SET_DISABLE_SEARCH_BUTTON(true);

            navigator.geolocation.getCurrentPosition(
              (position) => {
                this.successCallback(position);
                resolve();
              },
              (error) => {
                this.errorCallback(error);
                reject();
              }
            );
          } else {
            resolve();
          }
        });
      },
      getData(){
        this.loadingApi = true
        const route_queries = this.$route.query;
        if (route_queries.key) this.SET_KEY_FROM_URL(route_queries.key)
        if (route_queries.token) this.SET_TOKEN_FROM_URL(route_queries.token)

          let property_code
          let property_id

          if (route_queries.hasOwnProperty('pc') === true) {
            property_code = route_queries.pc;
            property_id = route_queries.property_id
          } else if (process.env.NODE_ENV === 'production') {
            window.location.href = 'http://www.hotelkeyapp.com/';
          }


          let payload = {
            property_code: property_code,
            property_id: property_id
          };

          if (route_queries.hasOwnProperty('img') || route_queries.hasOwnProperty('pn')) {
            this.property_details_for_background.url = this.sanitizeUrl(route_queries.img);
            this.property_details_for_background.property_name = route_queries.pn.replace('%20', ' ');
          }
          this.getHotelDetails(payload)
            .then( async (res) => {

              if (res.website_config.booking_color_id) {
                this.setCustomColor()
              }

              try {
                await this.handleGeolocation();
              }
              catch(error) {
                console.log(error)
              }

              await this.checkUserAuth(res);
              if (!this.$route.query.skip_search) {
                await this.getBookingProfile({count: 1})
              }
              else this.setWizardSteps()
              this.injectScript();


              this.loadingApi = false;
            })

      window.addEventListener('resize', this.handleResize)
      }
    },
    beforeMount(){
        this.getData()
    },
  };
  </script>


